export default {"src":"/_next/static/media/reserve-logo.55093298.svg","height":111,"width":358,"blurWidth":0,"blurHeight":0};